const attachmentFolderActions = {
  CREATE_DATASET_ATTACHMENT_FOLDER_ERROR: 'CREATE_DATASET_ATTACHMENT_FOLDER_ERROR',
  CREATE_DATASET_ATTACHMENT_FOLDER_SUCCESS: 'CREATE_DATASET_ATTACHMENT_FOLDER_SUCCESS',
  CREATE_DATASET_ATTACHMENT_FOLDER: 'CREATE_DATASET_ATTACHMENT_FOLDER',
  DATASET_ATTACHMENT_FOLDER_NAVIGATE: 'DATASET_ATTACHMENT_FOLDER_NAVIGATE',
  DATASET_ATTACHMENT_FOLDER_PUSH: 'DATASET_ATTACHMENT_FOLDER_PUSH',
  DELETE_DATASET_ATTACHMENT_FOLDER: 'DELETE_DATASET_ATTACHMENT_FOLDER',
  HIDE_CREATE_DATASET_ATTACHMENT_FOLDER: 'HIDE_CREATE_DATASET_ATTACHMENT_FOLDER',
  HIDE_DELETE_DATASET_ATTACHMENT_FOLDER: 'HIDE_DELETE_DATASET_ATTACHMENT_FOLDER',
  SHOW_CREATE_DATASET_ATTACHMENT_FOLDER: 'SHOW_CREATE_DATASET_ATTACHMENT_FOLDER',
  SHOW_DELETE_DATASET_ATTACHMENT_FOLDER: 'SHOW_DELETE_DATASET_ATTACHMENT_FOLDER',
  UPDATE_CREATE_DATASET_ATTACHMENT_FOLDER_PROPERTIES: 'UPDATE_CREATE_DATASET_ATTACHMENT_FOLDER_PROPERTIES',
};

const attachmentsActions = {
  DATASET_ATTACHMENT_DOWNLOAD: 'DATASET_ATTACHMENT_DOWNLOAD',
  DATASET_ATTACHMENT_DOWNLOAD_ERROR: 'DATASET_ATTACHMENT_DOWNLOAD_ERROR',
  DATASET_ATTACHMENT_DOWNLOAD_SUCCESS: 'DATASET_ATTACHMENT_DOWNLOAD_SUCCESS',
  DATASET_ATTACHMENT_UPLOAD_REMOVED: 'DATASET_ATTACHMENT_UPLOAD_REMOVED',
  DATASET_ATTACHMENT_UPLOAD_SUCCESS: 'DATASET_ATTACHMENT_UPLOAD_SUCCESS',
  DATASET_ATTACHMENTS_UPLOAD: 'DATASET_ATTACHMENTS_UPLOAD',
  DATASET_ATTACHMENTS_UPLOAD_FAIL: 'DATASET_ATTACHMENTS_UPLOAD_FAIL',
  DELETE_DATASET_ATTACHMENT: 'DELETE_DATASET_ATTACHMENT',
  DELETE_DATASET_ATTACHMENT_ERROR: 'DELETE_DATASET_ATTACHMENT_ERROR',
  DELETE_DATASET_ATTACHMENT_SUCCESS: 'DELETE_DATASET_ATTACHMENT_SUCCESS',
  FETCH_DATASET_ATTACHMENTS: 'FETCH_DATASET_ATTACHMENTS',
  FETCH_DATASET_ATTACHMENTS_ERROR: 'FETCH_DATASET_ATTACHMENTS_ERROR',
  FETCH_DATASET_ATTACHMENTS_SUCCESS: 'FETCH_DATASET_ATTACHMENTS_SUCCESS',
  HIDE_CONVERT_DATAFILE_DIALOG: 'HIDE_CONVERT_DATAFILE_DIALOG',
  HIDE_DELETE_DATASET_ATTACHMENT: 'HIDE_DELETE_DATASET_ATTACHMENT',
  HIDE_DOWNLOADABLE_CONFIRMATION_DIALOG: 'HIDE_DOWNLOADABLE_CONFIRMATION_DIALOG',
  HIDE_EDIT_DATASET_ATTACHMENT_DIALOG: 'HIDE_EDIT_DATASET_ATTACHMENT_DIALOG',
  SHOW_CONVERT_ATTACHMENT_DIALOG: 'SHOW_CONVERT_ATTACHMENT_DIALOG',
  SHOW_DATASET_ATTACHMENT_DICTIONARY: 'SHOW_DATASET_ATTACHMENT_DICTIONARY',
  SHOW_DATASET_ATTACHMENT_DICTIONARY_ERROR: 'SHOW_DATASET_ATTACHMENT_DICTIONARY_ERROR',
  SHOW_DELETE_DATASET_ATTACHMENT: 'SHOW_DELETE_DATASET_ATTACHMENT',
  SHOW_DOWNLOADABLE_CONFIRMATION_DIALOG: 'SHOW_DOWNLOADABLE_CONFIRMATION_DIALOG',
  SHOW_EDIT_DATASET_ATTACHMENT_DIALOG: 'SHOW_EDIT_DATASET_ATTACHMENT_DIALOG',
  TOGGLE_DATASET_ATTACHMENT_COLUMN_ORDER_BY: 'TOGGLE_DATASET_ATTACHMENT_COLUMN_ORDER_BY',
  TOGGLE_DATASET_ATTACHMENT_TYPE_FILTER: 'TOGGLE_DATASET_ATTACHMENT_TYPE_FILTER',
  UPDATE_ACTIVE_DICTIONARY_ATTACHMENT_PROPERTIES: 'UPDATE_ACTIVE_DICTIONARY_ATTACHMENT_PROPERTIES',
  UPDATE_DATASET_ATTACHMENT_DESCRIPTION: 'UPDATE_DATASET_ATTACHMENT_DESCRIPTION',
  UPDATE_DATASET_ATTACHMENT_DESCRIPTION_ERROR: 'UPDATE_DATASET_ATTACHMENT_DESCRIPTION_ERROR',
  UPDATE_DATASET_ATTACHMENT_DESCRIPTION_SUCCESS: 'UPDATE_DATASET_ATTACHMENT_DESCRIPTION_SUCCESS',
  UPDATE_DATASET_ATTACHMENT_METADATA: 'UPDATE_DATASET_ATTACHMENT_METADATA',
  UPDATE_DATASET_ATTACHMENT_METADATA_ERROR: 'UPDATE_DATASET_ATTACHMENT_METADATA_ERROR',
  UPDATE_DATASET_ATTACHMENT_METADATA_SUCCESS: 'UPDATE_DATASET_ATTACHMENT_METADATA_SUCCESS',
  UPDATE_DATASET_ATTACHMENT_PROPERTIES: 'UPDATE_DATASET_ATTACHMENT_PROPERTIES',
  UPDATE_DATASET_ATTACHMENT_TEXT_FILTER: 'UPDATE_DATASET_ATTACHMENT_TEXT_FILTER',
  ...attachmentFolderActions,
};

// Ordering is based on access level
export const ATTACHMENT_TRANSFER = {
  disabled: { name: 'disabled', icon: 'ban', order: 0 },
  optional: { name: 'optional', icon: 'check circle outline', order: 1 },
  recommended: { name: 'recommended', icon: 'thumbs up', order: 2 },
  required: { name: 'required', icon: 'asterisk', order: 3 },
};

// Ordering is based on access level
export const ATTACHMENT_VIEW = {
  hidden: {
    name: 'hidden', icon: 'eye slash', order: 0, className: 'primary',
  },
  viewable: {
    name: 'viewable', icon: 'eye', order: 1, className: 'primary',
  },
  downloadable: {
    name: 'downloadable', icon: 'download', order: 2, className: 'primary',
  },
};

export const ATTACHMENT_TYPE = {
  datafile: { name: 'datafile', icon: 'file excel outline' },
  attachment: { name: 'attachment', icon: 'file' },
  folder: { name: 'folder', icon: 'folder open' },
};

export default attachmentsActions;
